import { PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLeading } from 'redux-saga/effects';
import {
    genericBladeDropDownChange, genericBladeSubmit, GenericBladeSubmitPayload, NodePayload,
} from '@commblades/commblades';

import { removeExistingBladesAfter, startBladeNavigation } from '../../navigationSlice';
import Blades from '../Blades';
import { RootModel } from '../../types';
import { selectRootModel } from '../../../netBank/netBankSelectors';
import { DefaultYourFinanceSubmit, YourFinanceData } from '../yourFinance/yourFinanceTypes';
import { getYourFinanceFulfilled } from '../yourFinance/yourFinanceSlice';
import { updateSelectedSubLoanPurposeId } from '../../../netBank/netBankSlice';

function* subLoanPurposesBladeSubmitWorkSaga(action: PayloadAction<GenericBladeSubmitPayload>) {
    if (action.payload.id === 'sub-loanpurpose') {
        // Set selected sub loan purpose id
        const selectedSubLoanPurposeId = Number(action.payload.submittedPayload.form1);

        yield put(updateSelectedSubLoanPurposeId(selectedSubLoanPurposeId));
        const rootModel: RootModel = yield select(selectRootModel);

        const { borrowingInput } = rootModel;
        const yourFinance: YourFinanceData = JSON.parse(String(borrowingInput.content));

        yield put(getYourFinanceFulfilled({
            data: yourFinance,
            submitData: DefaultYourFinanceSubmit,
            isSubmitDataReady: false,
        }));
        yield put(startBladeNavigation(Blades.SubLoanPurpose.next));
    }
}

function* removeFollowBladesWorkSaga(action: PayloadAction<{
    id: string;
    selectedValue: NodePayload;
}>) {
    yield put(removeExistingBladesAfter('SubLoanPurpose'));
}

export function* subLoanPurposesBladeSubmitWatchSaga() {
    yield takeLeading(genericBladeSubmit.type, subLoanPurposesBladeSubmitWorkSaga);
    yield takeLeading(genericBladeDropDownChange.type, removeFollowBladesWorkSaga);
}
